import { Stack, Tab, Tabs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from '@/utils/routeHelper';
import { Link, useLocation } from 'react-router-dom';

export default function TopSeriesSummaryFilterSection() {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	const routeMatch = useRouteMatch(pathname, [
		'/exercise-manage/ding-day21',
		'/exercise-manage/top-series',
		'/exercise-manage/manage-tag',
	]);

	const currentTab = routeMatch?.pattern?.path;

	const tabList = [
		{
			name: 'dingDay21',
			tabText: t('drawerListItems.dingDay21'),
			tabValue: `/exercise-manage/ding-day21`,
			tabTo: `/exercise-manage/ding-day21`,
		},
		{
			name: 'topSeries',
			tabText: t('drawerListItems.topSeries'),
			tabValue: `/exercise-manage/top-series`,
			tabTo: `/exercise-manage/top-series`,
		},
		{
			name: 'unitTag',
			tabText: t('drawerListItems.unitTag'),
			tabValue: `/exercise-manage/manage-tag`,
			tabTo: `/exercise-manage/manage-tag`,
		},
	];

	return (
		<Stack>
			<Tabs value={currentTab} sx={{ borderBottom: 1, borderColor: 'divider' }}>
				{currentTab &&
					tabList.map((item) => (
						<Tab
							key={item.name}
							label={<Typography variant='body1'>{item.tabText}</Typography>}
							value={item.tabValue}
							to={item.tabTo}
							component={Link}
						/>
					))}
			</Tabs>
		</Stack>
	);
}
